"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditCreditSection = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));

var _typography = require("@creditas-lab/typography");

var _productTypes = require("../../constants/product-types");

var _utils = require("../../utils");

var _useEditCreditSection = require("./useEditCreditSection");

var _EditCreditSection = require("./EditCreditSection.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  value: _propTypes.number.isRequired,
  productType: (0, _propTypes.oneOf)([_productTypes.ProductTypes.AUTO, _productTypes.ProductTypes.HOME]),
  onChange: _propTypes.func.isRequired
} : {};

var EditCreditSection = function EditCreditSection(_ref) {
  var value = _ref.value,
      productType = _ref.productType,
      onChange = _ref.onChange;

  var _ref2 = (0, _useEditCreditSection.useEditCreditSection)({
    productType: productType,
    intendedCredit: value,
    onInputChange: onChange
  }),
      inputRef = _ref2.inputRef,
      viewMode = _ref2.viewMode,
      intendedCredit = _ref2.intendedCredit,
      onValueChange = _ref2.onValueChange,
      onToggleClick = _ref2.onToggleClick,
      inputPlaceholder = _ref2.inputPlaceholder;

  return (0, _core.jsx)(_EditCreditSection.Container, null, (0, _core.jsx)(_EditCreditSection.AmountContainer, null, (0, _core.jsx)(_EditCreditSection.Label, {
    desktop: "md",
    mobile: "sm",
    color: "neutral60",
    weigth: "sm"
  }, "De quanto voc\xEA precisa?"), (0, _core.jsx)(_EditCreditSection.InputContainer, null, (0, _core.jsx)(_typography.Typography, {
    desktop: "xl",
    mobile: "lg",
    color: "neutral90",
    weigth: "sm"
  }, "R$"), (0, _core.jsx)(_reactFocusLock.default, {
    autoFocus: !viewMode
  }, (0, _core.jsx)(_EditCreditSection.Input, {
    ref: inputRef,
    "data-testid": "credit-input",
    inputMode: "numeric",
    pattern: "[0-9]*",
    placeholder: inputPlaceholder,
    value: (0, _utils.formatPlainNumber)(intendedCredit),
    onChange: onValueChange,
    disabled: viewMode
  })))), (0, _core.jsx)(_EditCreditSection.ToggleButton, {
    onClick: onToggleClick,
    "data-testid": "toggle-edit-credit-button"
  }, viewMode ? 'Editar' : 'Simular'));
};

exports.EditCreditSection = EditCreditSection;
process.env.NODE_ENV !== "production" ? EditCreditSection.propTypes = propTypes : void 0;
EditCreditSection.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EditCreditSection",
  "props": {
    "value": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": ""
    },
    "productType": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "ProductTypes.AUTO",
          "computed": true
        }, {
          "value": "ProductTypes.HOME",
          "computed": true
        }]
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};